import { DownOutlined } from '@ant-design/icons'
import { MembershipProfile } from '@models/membership/MembershipProfile'
import { detachAppUserFromMembershipProfile } from '@services/membership/MembershipProfileService'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  selectMembershipProfileById,
  updateMembershipProfile,
} from '@store/membership/MembershipProfileReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { App, Button, Dropdown, Popconfirm, Typography } from 'antd'
import { FC, useState } from 'react'
import { DEFAULT_SUCCESS } from '../../../App'

const { Text } = Typography

type Props = SBModelComponent<MembershipProfile> & {}

export const ActionDropdown: FC<Props> = ({ id, model }) => {
  const { message } = App.useApp()
  const dispatch = useAppDispatch()
  const item = model ? model : useAppSelector(selectMembershipProfileById(id!))

  const [isOpen, setIsOpen] = useState<boolean>(false)

  if (!item) return <></>

  const toggleMembershipProfileIsActive = async () => {
    try {
      await dispatch(
        updateMembershipProfile({
          ...item,
          isActive: !item.isActive,
        })
      )
      message.success(DEFAULT_SUCCESS)
    } catch (_) {
      message.error(DEFAULT_SUCCESS)
    }
    setIsOpen(false)
  }

  return (
    <Dropdown
      placement="bottomRight"
      open={isOpen}
      onOpenChange={(nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
          setIsOpen(nextOpen)
        }
      }}
      menu={{
        items: [
          {
            key: '1',
            onClick: () => setIsOpen(false),
            label: (
              <SBRM.Actions
                entity={Entity.membershipProfiles}
                entityId={item.id}
                actions={[SBRMAction.Update]}
                trigger={'Edit member infos'}
              />
            ),
          },
          {
            key: '2',
            label: (
              <Popconfirm
                disabled={!item.hasAppUser}
                title="Confirm app profile detachment"
                description={
                  <Text>
                    By detaching the Member Profile from the User Profile,
                    <br />
                    the user will immediately lose access to all
                    membership-related benefits within the application,
                    <br />
                    and their associated Loyalty Tier will be unassigned
                    accordingly.
                  </Text>
                }
                onConfirm={async () => {
                  await detachAppUserFromMembershipProfile(item.id)
                  setIsOpen(false)
                  window.location.reload()
                }}
              >
                <Text disabled={!item.hasAppUser} type="danger">
                  Detach app profile
                </Text>
              </Popconfirm>
            ),
          },
          ...[
            item.isActive
              ? {
                  key: 'action-restrict-member-access',
                  label: (
                    <Popconfirm
                      title="Are you sure you want to restrict this member's ?"
                      description={
                        <Text>
                          This action will immediately remove all membership
                          <br />
                          benefits and detach the current loyalty tier from
                          <br />
                          the profile.
                        </Text>
                      }
                      onConfirm={toggleMembershipProfileIsActive}
                    >
                      <Text type="danger">Restrict member access</Text>
                    </Popconfirm>
                  ),
                }
              : {
                  key: 'action-restore-member-access',
                  label: 'Restore member access',
                  onClick: toggleMembershipProfileIsActive,
                },
          ],
        ],
      }}
    >
      <Button icon={<DownOutlined />} iconPlacement="end">
        Actions
      </Button>
    </Dropdown>
  )
}
